import { combineReducers } from "redux";

import formComment from "./formComment";
import getComments from "./getComments";
import getNewsDetail from "./getNewsDetail";
import getNewsTabs from "./getNewsTabs";
import likeNews from "./likeNews";
import newsFilterForm from "./newsFilterForm";
import postComment from "./postComment";

import getNews from "./getNews";

const newsReducer = combineReducers({
  likeNews,
  getNewsTabs,
  newsFilterForm,
  getComments,
  postComment,
  formComment,
  getNews,
  getNewsDetail
});

export default newsReducer;
